// extracted by mini-css-extract-plugin
export default {"skeleton-group-container":"SkeletonGroup_skeleton-group-container__HXB-e"};